// extracted by mini-css-extract-plugin
module.exports = {"grid":"Features_grid__2McYS","card":"Features_card__3PhuK","iconWrapper":"Features_iconWrapper__3EtP7","title":"Features_title__2P7-0"};